<template>
    <div :class="cardClasses" @click="$emit('click')">
        <div class="card">
            <div class="card-body">
                <div class="nome-linha">
                    <div class="icone-container">
                        <IconeSvg :nome="icone" />
                    </div>
                    <div class="nome-container">
                        <h6 class="mb-0 text-center nome-artefato" :title="tituloCompleto" v-html="formatarNome(nmModelo)"></h6>
                    </div>
                </div>

                <div class="rodape">
                    <div class="info-container">
                        <div class="info-item responsavel">
                            <small class="text-truncate" :title="nmUsuario || 'Não designado'">
                                <i class="fas fa-user"></i>
                                <span>{{ nmUsuario || 'Não designado' }}</span>
                            </small>
                        </div>
                        <div class="info-item prazo">
                            <small class="text-truncate">
                                <i class="fas fa-calendar-alt"></i>
                                <span>{{ dtLimiteFmt || 'Sem Prazo Definido' }}</span>
                            </small>
                        </div>
                    </div>

                    <div class="status-indicator" :class="indicatorClass">
                    <svg v-if="flEnviado" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                    </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconeSvg from '@/components/IconeSvg.vue'

    export default {
        name: 'CardArtefato',
        components: { IconeSvg },
        props: {
            nmModelo: String,
            icone: String,
            flEnviado: Boolean,
            flRetificado: Boolean,
            nmUsuario: { type: String, default: '' },
            dtLimite: { type: String, default: '' },
            bloqueado: { type: Boolean, default: false },
        },
        computed: {
            statusVisual() {
                if (this.flEnviado) return 'success'
                if (this.bloqueado) return 'blocked'
                const prazo = this.parseDateOnly(this.dtLimite)
                if (!prazo) return 'warning'
                const hoje = this.today()
                return prazo < hoje ? 'danger' : 'warning'
            },
            cardClasses() {
                return [
                    'col',
                    'item-artefato',
                    this.statusVisual === 'success' ? 'item-artefato-ativo'
                        : this.statusVisual === 'blocked' ? 'item-artefato-inativo'
                            : this.statusVisual === 'warning' ? 'item-artefato-warning'
                                : /* danger */                    'item-artefato-danger'
                ].join(' ')
            },
            indicatorClass() {
                return {
                    'text-success': this.statusVisual === 'success',
                    'text-warning': this.statusVisual === 'warning',
                    'text-danger': this.statusVisual === 'danger',
                    'text-muted': this.statusVisual === 'blocked',
                }
            },
            isMobile() {
                return window.innerWidth < 1400
            },
            temMeta() {
                return !!(this.nmUsuario || this.dtLimiteFmt)
            },
            tituloCompleto() {
                const nome = this.nmModelo || ''
                return nome + (this.flRetificado ? ' (Ret.)' : '')
            },
            dtLimiteFmt() {
                return this.formatarData(this.dtLimite)
            },
        },
        methods: {
            formatarNome(nome) {
                if (nome === 'Mapa de Risco') return 'Mapa de<br>Risco' + (this.flRetificado ? ' (Ret.)' : '')
                return nome + (this.flRetificado?' (Ret.)':'')
            },
            // compara SEM horário/timezone: YYYY-MM-DD -> Date na meia-noite local
            parseDateOnly(v) {
                if (!v) return null;
                const s = String(v).slice(0, 10);
                if (s === '0001-01-01' || s === '1901-01-01') return null;
                if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                    const [y, m, d] = s.split('-').map(n => parseInt(n, 10));

                    const dt = new Date(0);
                    dt.setFullYear(y, m - 1, d);
                    dt.setHours(0, 0, 0, 0);
                    return dt;
                }

                const d = new Date(v);
                if (isNaN(d)) return null;

                const dt = new Date(0);
                dt.setFullYear(d.getFullYear(), d.getMonth(), d.getDate());
                dt.setHours(0, 0, 0, 0);
                return dt;
            },

            today() {
                const now = new Date()
                return new Date(now.getFullYear(), now.getMonth(), now.getDate())
            },
            formatarData(v) {
                const d = this.parseDateOnly(v)
                if (!d) return ''
                const dd = String(d.getDate()).padStart(2, '0')
                const mm = String(d.getMonth() + 1).padStart(2, '0')
                const yyyy = d.getFullYear()
                return `${dd}/${mm}/${yyyy}`
            },
        },
        mounted() {

        },
        watch: {

        }
    }
</script>

<style scoped>
    .item-artefato {
        position: relative;
        cursor: pointer;
        display: flex;
        min-height: 6.45rem;
        height: auto;
        min-width: 12.8rem;
    }

        .item-artefato .card {
            position: relative;
            background-color: inherit;
            border: 2px solid #10B981; /* default = success (será sobrescrito pelas classes abaixo) */
            padding: 0.4rem;
            width: 100%;
            min-height: 6.45rem;
            height: auto;
            display: flex;
            flex-direction: column;
            transition: transform .2s ease, box-shadow .2s ease;
            border-radius: 16px;
        }

    /* Layout do card */
    .card-body {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        height: auto;
        padding: 0.35rem 0.4rem 0.2rem;
        gap: 0.2rem;
    }

    .nome-linha {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        gap: 0.35rem;
        min-width: 0;
    }

    /* Ícone ao lado do nome, sem cobrir o texto */
    .icone-container {
        position: static;
        flex: 0 0 1.2rem;
        align-self: flex-start;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.05rem;
    }

        .icone-container svg {
            width: 1.2rem;
            height: 1.2rem;
            opacity: 0.8;
            flex-shrink: 0;
        }

    .nome-container {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nome-artefato {
        width: 100%;
        min-width: 0;
        font-size: 0.85rem;
        font-weight: 600;
        line-height: 1.2;
        overflow-wrap: break-word;
        word-break: break-word;
    }

    .rodape {
        flex: 0 0 auto;
        display: flex;
        align-items: flex-end;
        gap: 0.35rem;
        margin-top: auto;
    }

    .info-container {
        position: relative;
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 0.05rem;
    }

    .info-item {
        font-size: 0.85rem;
        line-height: 1.1;
        display: flex;
        align-items: center;
        overflow: hidden;
    }

        .info-item small {
            display: flex;
            align-items: center;
            max-width: 100%;
            min-width: 0;
            white-space: nowrap;
            gap: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
        }

            .info-item small span {
                display: inline-block;
                min-width: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

        .info-item i {
            flex: 0 0 auto;
            width: 0.75rem;
            font-size: 0.6rem;
            text-align: center;
            opacity: 0.8;
        }

    .status-indicator {
        position: static;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        line-height: 0;
    }

        .status-indicator svg {
            width: 16px;
            height: 16px;
            flex-shrink: 0;
        }

    /* BLOQUEADO (cinza) - reaproveita estilo antigo "inativo" */
    .item-artefato-inativo .card {
        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
        border-color: #5C686B;
        color: #5C686B;
        box-shadow: 0 4px 12px rgba(92, 104, 107, 0.15);
    }

    [data-bs-theme="dark"] .item-artefato-inativo .card {
        background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
    }

    .item-artefato-inativo .card *,
    .item-artefato-inativo .card svg {
        color: #5C686B !important;
        fill: #5C686B !important;
    }

    /* WARNING (amarelo) */
    .item-artefato-warning .card {
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border-color: #F59E0B; /* amber-500 */
        color: #F59E0B;
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
    }

    [data-bs-theme="dark"] .item-artefato-warning .card {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
    }

    .item-artefato-warning .card *,
    .item-artefato-warning .card svg {
        color: #F59E0B !important;
        fill: #F59E0B !important;
    }

    /* DANGER (vermelho) */
    .item-artefato-danger .card {
        background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
        border-color: #EF4444; /* red-500 */
        color: #EF4444;
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);
    }

    [data-bs-theme="dark"] .item-artefato-danger .card {
        background: linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%);
    }

    .item-artefato-danger .card *,
    .item-artefato-danger .card svg {
        color: #EF4444 !important;
        fill: #EF4444 !important;
    }

    /* SUCCESS (verde) - já existia como "ativo" */
    .item-artefato-ativo .card {
        background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
        border-color: #10B981;
        color: #10B981;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
    }

    [data-bs-theme="dark"] .item-artefato-ativo .card {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
    }

    .item-artefato-ativo .card *,
    .item-artefato-ativo .card svg {
        color: #10B981 !important;
        fill: #10B981 !important;
    }

    /* Hovers */
    .item-artefato:hover {
        z-index: 1002;
        position: relative;
    }

    .item-artefato-inativo:hover .card {
        transform: scale(1.02);
        box-shadow: 0 6px 16px rgba(92, 104, 107, 0.25);
    }

    .item-artefato-warning:hover .card {
        transform: scale(1.02);
        box-shadow: 0 6px 16px rgba(245, 158, 11, 0.25);
    }

    .item-artefato-danger:hover .card {
        transform: scale(1.02);
        box-shadow: 0 6px 16px rgba(239, 68, 68, 0.25);
    }

    .item-artefato-ativo:hover .card {
        transform: scale(1.02);
        box-shadow: 0 6px 16px rgba(16, 185, 129, 0.25);
    }


    /* Responsividade para mobile */
    @media (max-width: 768px) {
        .item-artefato {
            min-width: 10rem;
            min-height: 5.5rem;
            height: auto;
        }

        .item-artefato .card {
            min-height: 5.5rem;
        }

        .nome-artefato {
            font-size: 0.75rem;
        }

        .info-item {
            font-size: 0.6rem;
        }

        .icone-container svg {
            width: 1rem;
            height: 1rem;
        }
    }
</style>